import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
} from "../../components";
import {
  useDeleteFinancialPeriod,
  useGetFinancialPeriodDetails,
} from "../../hooks/react-query/useFinancialsData";
import { useDialogContext } from "../HubDialogWrapper";

const DeleteFinancialPeriodContent = () => {
  const { onClose, open } = useDialogContext();
  const id = typeof open === "number" ? open : null;

  const { data: period } = useGetFinancialPeriodDetails(id);
  const { mutate: deletePeriod, isLoading, isSuccess } =
    useDeleteFinancialPeriod();

  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess]);

  const onSubmit = () => {
    if (id) deletePeriod(id);
  };

  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="20px" alignItems="center" textAlign="center">
          <Typography variant="h6">Delete Financial Period</Typography>
          <Typography variant="caption">
            Are you sure you want to delete{" "}
            <strong>{period?.name || "this period"}</strong>? This action cannot
            be undone. Periods used by any quote cannot be deleted.
          </Typography>
          <HubCancelSubmitGroup
            disabled={isLoading || !id}
            isLoading={isLoading}
            label="Delete"
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default DeleteFinancialPeriodContent;
